import axios from 'axios'
import { config } from '../Config/config'

const eduService = {

    getAll: () => {
        const result = axios.get(config.apiUrl + '/level_edu')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/add_level_edu', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/LevelEduById/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    EditData: (data) => {
        const result = axios.put(config.apiUrl + '/level_edu', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    //delete data
    deleteData: (id) => {
        const result = axios.delete(config.apiUrl + '/level_edu/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    softDeleteData: (data) => {
        const result = axios.put(config.apiUrl + '/del_level_edu', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/level_edu', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    countData: () => {
        const result = axios.get(config.apiUrl + '/count_level_edu')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    dupeData: (name) => {
        const result = axios.get(config.apiUrl + '/level_edu/'+ name)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default eduService